export const ACTION = {
    IAP_DATA: 'IAP_DATA',
    IAP_CALL_US: 'IAP_CALL_US',
    GET_EDU_COURSES_CONTENT: 'GET_EDU_COURSES_CONTENT',
    IAP_FAQS: 'IAP_FAQS',
};